import type { CSSProperties } from 'react';

import { cn } from '@/utils';

import { useAnchorable } from '../../hooks/useAnchorable';

import { bottomContainer, description, list, listContainer, listInline, question, topContainer } from './Poll.css';
import type { TPostPollProps } from './Poll.types';
import { PollChoice } from './PollChoice';

const getListStyleType = (pollStyle?: string) => {
  if (pollStyle === 'bullet_points') return 'disc';
  if (pollStyle === 'numbered_list') return 'decimal';
  return 'none';
};

export const PostPoll = ({
  element,
  loginPath,
  subscribePath,
  isSubscriberAuthenticated,
  translations,
}: TPostPollProps) => {
  const { anchorAttributes } = useAnchorable(element.attrs);

  const { data: poll } = element.attrs;
  if (!poll) {
    return null;
  }

  const { question: questionText, description: descriptionText } = poll || {};
  const pollStyle = poll?.poll_style || 'default';

  return (
    <div
      {...anchorAttributes}
      style={
        {
          ...(['unstyled', 'inline'].includes(pollStyle)
            ? {
                '--list-container-padding-left': '0px',
                '--list-container-padding-right': '0px',
              }
            : {}),
          '--list-style-type': getListStyleType(pollStyle),
        } as CSSProperties
      }
    >
      <div>
        <div className={topContainer}>
          {questionText && <h3 className={question}>{questionText}</h3>}
          {descriptionText && <div className={description}>{descriptionText}</div>}
        </div>
        <div className={bottomContainer}>
          <div className={listContainer}>
            <ul className={cn(list, pollStyle === 'inline' && listInline)}>
              {poll?.poll_choices?.map((choice, index) => (
                <PollChoice
                  choice={choice}
                  key={`${choice.id}-${choice.response_url}`}
                  pollStyle={pollStyle}
                  isLast={index === poll?.poll_choices?.length - 1}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
      {isSubscriberAuthenticated !== true && (
        <div className={bottomContainer}>
          <p style={{ color: 'var(--post-section-text-color, --wt-text-on-background)' }}>
            <span>
              <a href={loginPath} className="underline">
                {translations?.['shared.cta.login']}
              </a>
            </span>{' '}
            {translations?.['shared.cta.or']}{' '}
            <span>
              <a href={subscribePath} className="underline">
                {translations?.['shared.cta.subscribe']}
              </a>
            </span>{' '}
            {translations?.['shared.cta.to_participate']}
          </p>
        </div>
      )}
    </div>
  );
};
